import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=194e62b7&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=ts&"
export * from "./Consent.vue?vue&type=script&lang=ts&"
import style0 from "./Consent.vue?vue&type=style&index=0&id=194e62b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e62b7",
  null
  
)

export default component.exports